import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import { useState, useEffect, useRef } from "react";
import {
    getLoadMoreQuestionData,
    getResearcherTestResultData,
    getResearcherTestResultDataV2,
    getTestQuestionResultData,
    generateAISummary,
    submitAiSummarizeFeedback,
} from "../../../services/researcher_test_results";
import HideParticipant from "./dialog/hide-participant";
import moment from "moment";
import ReportAnswer from "./dialog/report-answer";
import { useRecoilState } from "recoil";
import { testResultAtomFamily, testProjectAtomFamily } from "../../../store/testResultAtoms";
import { TestResultsHeader } from "./../../themes/userq/TestResultsHeader/TestResultsHeader";
import { QuestionsDropdown } from "../../themes/userq/QuestionsDropdown/QuestionsDropdown";
import { ByUserTable } from "../../themes/userq/ByUserTable/ByUserTable";
import { Text } from "../../themes/userq/Text/Text";
import { Search } from "./../../themes/userq/Search/Search";
import { TestResultsSidebarNavigation } from "./components/test_results_sidebar_navigation";
import { AggregatedDataTable } from "./../../themes/userq/AggregatedDataTable/AggregatedDataTable";
import { renderTestTitle, showToast } from "../../../lib/helpers";
import { PieStatsBoxSingleChoice } from "./components/pie_stats_box_singlechoice";
import { LoadingIcon } from "../../loader/loadingIconNew";
import { HorizontalBarChartStatsBoxMultipleChoice } from "./components/horizontal_bar_chart_stats_box_multiplechoice";
import { LikertScaleChart } from "../../themes/userq/LikertScaleChart/LikertScaleChart";
import { LikertScaleByUser } from "./../../themes/userq/LikertScaleByUser/LikertScaleByUser";
import { LikertScaleAggregateData } from "./../../themes/userq/LikertScaleAggregateData/LikertScaleAggregateData";
import { HorizontalBarChartStatsBoxRankingScale } from "./components/horizontal_bar_chart_stats_box_rankingscale";
import { Helmet } from "react-helmet";
import { RatingScaleChart } from "../../themes/userq/RatingScale/RatingScaleChart";
import { RatingMultiSelect } from "../../themes/userq/MultiSelecteDropdownList/RatingMultiSelect";
import InnerNavigationTab from "../../themes/userq/InnernavigationTab/innerNavigationTab";
import { AIFeatureBanner } from "./components/ai_feature_banner";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Button } from "../../themes/userq/Button/Button";

const MAX_AI_SENTIMENT_ROWS = 50;
export function compare(a, b) {
    const value1 = a[1]["averageranking"];
    const value2 = b[1]["averageranking"];

    let comparison = 0;

    if (value1 > value2) {
        comparison = -1;
    } else if (value1 < value2) {
        comparison = 1;
    }
    return comparison;
}

export default function QuestionAnswerIntroductionAndConclusionResult({
    isSharedLink,
}) {
    const { test_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const scrollContainerRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const is_introduction =
        location.pathname.indexOf("conclusion-questions") <= 0;

    const [isLoading, setLoading] = useState(false);
    const [sectionLoading, setSectionLoading] = useState(false);
    const [test, setTest] = useRecoilState(testResultAtomFamily(test_id));
    const [questionArray, setQuestionArray] = useState([]);
    const [isActive, setActive] = useState(0);
    const [activeMenu, setActiveMenu] = useState("chart");
    const [loadMoreLoading, setLoadMoreLoading] = useState(false);

    const [openDeleteAnswerModal, setOpenDeleteAnswerModal] = useState({
        active: false,
        test_result_id: null,
        hidden_result: false,
    });
    const [openReportAnswerModal, setOpenReportAnswerModal] = useState({
        active: false,
        answer_id: null,
    });

    const [answerArray, setAnswerArray] = useState([]);
    const [aggregrateArray, setAggregrateArray] = useState([]);
    const [metaData, setMetaData] = useState({
        questionType: "",
        anyOptionHaveImage: false,
        totalResultCount: 0,
        userType: "",
        aggregate_total_voters: 0,
        sort_time: "",
        sort_date: "",
        sort_vote: "",
        load_more: "",
        test_question_id: "",
        page: 1,
    });
    const [search, setSearch] = useState("");
    const [searchByUser, setSearchByUser] = useState("");
    const [rating, setRating] = useState([]);
    const [searchAggregateData, setSearchAggregateData] = useState("");
    const [searchLoading, setSearchLoading] = useState("");
    const [matrixArray, setMatrixArray] = useState([]);
    const [chartData, setChartData] = useState({});
    const [likertQuestion, setLikertQuestion] = useState({});
    const [predictions, setPredictions] = useState({
        average: null,
        csat: null,
        nps: null,
    });

    const [sortedchartData, setSortedChartData] = useState([]);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [rankingchartData, setRankingChartData] = useState({});
    const [rankingTableData, setRankingTableData] = useState([]);
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [show_support_panel, setShowSupportPanel] = useState(false);
    const [aggrgateQuestionsResultCount, setAggrgateQuestionsResultCount] = useState(0);

    const [aiSummary, setAiSummary] = useState(null);
    const [helpfulVote, setHelpfulVote] = useState(null);
    const [aiSummaryLoading, setAiSummaryLoading] = useState(false);
    const [aiAssistantEnabled, setAiAssistantEnabled] = useState(false);

    const resetAiSummaryState = () => {
        setAiSummary(null);
        setHelpfulVote(null);
        setAiSummaryLoading(false);
        setAiAssistantEnabled(false);
        setAnswerArray((prev) =>
            prev.map((item) => ({
                ...item,
                ai_summary: null,
            }))
        );
    };

    const handleAiAssistantToggle = (isEnabled) => {
        setAiAssistantEnabled(isEnabled);
        if (!isEnabled) {
            resetAiSummaryState();
        }
    };

    const [project, setProject] = useRecoilState(testProjectAtomFamily(test_id));

    const searchController = useRef();
    const searchDebounceRef = useRef(null);

    const getTestafterEndTest = () => {
        let token = ReactSession.get("token");

        let guest_result_token = "";

        if (location.pathname.slice(1, 2) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).slice(2, 17);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.slice(1, 2) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).slice(2, 17);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getResearcherTestResultData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setLoading(false);
            if (response?.success) {
                setTest(response.test);
            } else {
                showToast(response?.message, "error");
            }
        });
    };

    const getTest = () => {
        if (!test) {
            let token = ReactSession.get("token");

            setLoading(true);

            let guest_result_token = "";
            if (location.pathname.slice(1, 2) === "v") {
                if (!ReactSession.get("guest_result_token")) {
                    const randomToken = Math.random().toString(36).slice(2, 17);
                    ReactSession.set("guest_result_token", randomToken);
                }

                guest_result_token = ReactSession.get("guest_result_token");
            }
            let admin_result_token = "";

            if (location.pathname.slice(1, 2) === "a") {
                if (!ReactSession.get("admin_result_token")) {
                    const randomToken = Math.random().toString(36).slice(2, 17);
                    ReactSession.set("admin_result_token", randomToken);
                }

                admin_result_token = ReactSession.get("admin_result_token");
            }

            getResearcherTestResultDataV2(
                test_id,
                token,
                guest_result_token,
                admin_result_token
            ).then((response) => {
                setLoading(false);
                if (response?.success && response.data?.test) {
                    const { test: testData, current_team_member, is_share_result } = response.data;

                    if (current_team_member) {
                        if (current_team_member.status !== "active") {
                            navigate(
                                "/wsp/" +
                                current_team_member.workspace_id +
                                "/p/" +
                                current_team_member.workspace_project_id +
                                "/project-no-access"
                            );
                        }
                    }

                    if (testData.workspace_project) {
                        setProject(testData.workspace_project);
                    }

                    if (location.pathname.slice(1, 2) === "v" && is_share_result) {
                        navigate(`/v/results/${test_id}/results-not-available`);
                    }

                    if (location.pathname.slice(1, 2) === "v" && testData.password) {
                        navigate(`/v/results/${test_id}/password`);
                    }

                    setTest(testData);
                    getQuestions();
                } else {
                    if (response?.message === "Project not found.") {
                        navigate("/404");
                    } else if (response?.message === "Test Record Not found") {
                        navigate("/404");
                    } else {
                        if (location.pathname.slice(1, 2) === "v") {
                            return navigate(`/v/results/${test_id}/results-not-available`);
                        }
                        if (location.pathname.slice(1, 2) === "a") {
                            return navigate(`/v/results/${test_id}/results-not-available`);
                        }
                        showToast(response?.message, "error");
                    }
                }
            });
        } else {
            getQuestions();
        }
    };

    const getQuestions = () => {
        let token = ReactSession.get("token");

        setSectionLoading(true);

        let guest_result_token = "";
        if (location.pathname.slice(1, 2) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";
        if (location.pathname.slice(1, 2) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        getTestQuestionResultData(
            {
                test_id: test_id,
                type:
                    location.pathname.split("/").pop() ===
                        "introduction-questions"
                        ? "briefing"
                        : "debriefing",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setSectionLoading(false);
            if (response?.success) {
                let aggregate_result_count = 0;
                response.data.forEach(function (question) {
                    aggregate_result_count += question.result_count;
                });
                setAggrgateQuestionsResultCount(aggregate_result_count);
                setQuestionArray(response.data);
                changeActiveQuestion(1, response.data);
            } else {
                showToast(response?.message, "error");
            }
        });
    };

    const handleScroll = () => {
        const scrolled = scrollContainerRef.current.scrollTop > 0;
        setIsScrolled(scrolled);
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);

            return () => {
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [rankingTableData]);

    useEffect(() => {
        document.title =
            process.env.REACT_APP_NAME + " - test result questions";
        getTest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        return () => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
        };
    }, []);

    const callbackTopbar = (data) => {
        getTest();
        getTestafterEndTest();
    };

    const changeActiveQuestion = (index, data) => {
        setActive(index);
        setSearch("");
        setActiveMenu("chart");
        setSearchByUser("");
        setRating([]);
        resetAiSummaryState();
        const dataAnswer = data.filter(
            (item, indexItem) => indexItem + 1 === index
        )[0];

        if (dataAnswer) {
            if (dataAnswer.question_type === "multiplechoice") {
                setChartData(dataAnswer.chartDataMultipleChoice);
            } else {
                setChartData(dataAnswer.chartData);
            }
            const resultArray = dataAnswer.result;

            setAnswerArray(resultArray);
            setAggregrateArray(dataAnswer.aggregate);
            setMetaData({
                anyOptionHaveImage: dataAnswer.any_option_have_image
                    ? dataAnswer.any_option_have_image
                    : false,
                questionType: dataAnswer.question_type,
                totalResultCount: dataAnswer.result_count,
                userType:
                    dataAnswer.question_type === "likertscale"
                        ? "chart"
                        : dataAnswer.question_type === "free"
                            ? "by-user"
                            : "chart",
                aggregate_total_voters: dataAnswer.aggregate_total_voters,
                sort_result_id: "asc",
                sort_time: "",
                sort_date: "",
                sort_vote: "",
                load_more: dataAnswer.result_count > 10 ? true : false,
                test_question_id: dataAnswer.id,
                page: 1,
            });
            if (dataAnswer.question_type === "rankingscale") {
                setRankingChartData(dataAnswer.rankingchartData);
                setRankingTableData([dataAnswer.rankingtableData]);
            }
            if (
                dataAnswer.question_type === "likertscale" ||
                dataAnswer.question_type === "likertscale_single"
            ) {
                let matrixData = [];

                dataAnswer.matrix.forEach((items) => {
                    var totalheat = 0;
                    dataAnswer.matrix.forEach((entry) => {
                        if (items.y === entry.y) {
                            totalheat = totalheat + entry.heat;
                        }
                    });
                    var fill = "";
                    if (
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 >=
                        80
                    ) {
                        fill = "#5C208D";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 >=
                        60 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 <
                        80
                    ) {
                        fill = "#793EAB";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 >=
                        40 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 <
                        60
                    ) {
                        fill = "#9759CB";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 >=
                        20 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 <
                        40
                    ) {
                        fill = "#BF8EE8";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 >
                        0 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) /
                        100 <
                        20
                    ) {
                        fill = "#EFDCFF";
                    } else {
                        fill = "#E9E9E9";
                    }

                    matrixData.push({
                        x: items.x,
                        y: items.y,
                        heat: items.heat,
                        fill: fill,
                        participants:
                            Math.round(((items.heat * 100) / totalheat) * 100) /
                            100 +
                            "% Participants",
                        percent_participants:
                            Math.round(((items.heat * 100) / totalheat) * 100) /
                            100,
                    });
                });

                setMatrixArray(matrixData);
                setLikertQuestion(dataAnswer.questions);
            }
            if (dataAnswer.question_type === "ratingscale") {
                setMatrixArray(dataAnswer.matrix);
                setLikertQuestion(dataAnswer.questions);
                setPredictions({
                    average: dataAnswer.average,
                    nps: dataAnswer.nps,
                    csat: dataAnswer.csat,
                });
            }
            let sortable = [];
            for (var option in dataAnswer.chartData) {
                sortable.push([option, dataAnswer.chartData[option]]);
            }

            sortable.sort(function (a, b) {
                return b[1] - a[1];
            });

            setSortedChartData(sortable);
        }
    };

    const sortData = (type) => {
        if (type === "time") {
            if (metaData.sort_time === "asc") {
                sortDataApi("time", "desc");
            } else {
                sortDataApi("time", "asc");
            }
        } else if (type === "date") {
            if (metaData.sort_date === "asc") {
                sortDataApi("date", "desc");
            } else {
                sortDataApi("date", "asc");
            }
        } else if (type === "vote") {
            if (metaData.sort_vote === "asc") {
                setAggregrateArray(
                    aggregrateArray.sort((a, b) => (a.vote < b.vote ? 1 : -1))
                );
                setMetaData({ ...metaData, sort_vote: "desc" });
            } else {
                setAggregrateArray(
                    aggregrateArray.sort((a, b) => (a.vote > b.vote ? 1 : -1))
                );
                setMetaData({ ...metaData, sort_vote: "asc" });
            }
        } else if (type === "result_id") {
            if (metaData.sort_result_id === "asc") {
                sortDataApi("result_id", "desc");
            } else {
                sortDataApi("result_id", "asc");
            }
        }
    };

    const sortDataApi = (sortColumn, orderBy) => {
        setSortBy(sortColumn);
        setSortOrder(orderBy);

        let guest_result_token = "";
        if (location.pathname.slice(1, 2) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }

        let admin_result_token = "";
        if (location.pathname.slice(1, 2) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        let token = ReactSession.get("token");
        getLoadMoreQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: 1,
                type: metaData.questionType,
                search: metaData.questionType === "free" ? search : searchByUser,
                sort_column: sortColumn,
                order_by: orderBy,
                questiontype: is_introduction ? "Introduction" : "Conclusion",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
                previous_summary: aiSummary,
                generate_ai_summary: aiAssistantEnabled,
            },
            token
        ).then((response) => {
            if (response?.success) {
                setAnswerArray(response.data);

                if (sortColumn === "time") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "desc",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "asc",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                } else if (sortColumn === "result_id") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "desc",
                            sort_time: "",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "asc",
                            sort_time: "",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                } else {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "",
                            sort_date: "desc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "",
                            sort_date: "asc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                }
            } else {
                showToast(response?.message, "error");
            }
        });
    };

    const loadMore = () => {
        setLoadMoreLoading(true);

        let guest_result_token = "";

        if (location.pathname.slice(1, 2) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";
        if (location.pathname.slice(1, 2) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        let token = ReactSession.get("token");
        getLoadMoreQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: metaData.page + 1,
                type: metaData.questionType,
                search: metaData.questionType === "free" ? search : searchByUser,
                sort_column: sortBy,
                order_by: sortOrder,
                questiontype: is_introduction ? "Introduction" : "Conclusion",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
                previous_summary: aiSummary,
                generate_ai_summary: aiAssistantEnabled,
            },
            token
        ).then((response) => {
            setLoadMoreLoading(false);
            if (response?.success) {
                const aiResponse = response?.ai_summary?.data ?? null;
                setAiSummary(aiResponse?.summary ?? null);

                const summaryMap = {};
                const aiSummaryResponses = aiResponse?.responses;
                if (aiSummaryResponses && Array.isArray(aiSummaryResponses)) {
                    aiSummaryResponses.forEach((summaryItem) => {
                        summaryMap[summaryItem.responseTextId] = {
                            responseText: summaryItem.responseText,
                            label: summaryItem.label,
                            responseTextId: summaryItem.responseTextId,
                        };
                    });
                }

                const newDataWithAI = response.data.map((item) => {
                    if (summaryMap[item.id]) {
                        return {
                            ...item,
                            ai_summary: summaryMap[item.id]
                        };
                    }
                    return item;
                });

                setAnswerArray(answerArray.concat(newDataWithAI));
                setMetaData({
                    ...metaData,
                    page: metaData.page + 1,
                    load_more: response.more_records,
                });
            } else {
                showToast(response?.message, "error");
            }
        });
    };

    const hideParticipantModal = (id, hiddenResult) => {
        setOpenDeleteAnswerModal({
            active: true,
            test_result_id: id,
            hidden_result: hiddenResult,
        });
    };

    const closeDeleteAnswerModal = (data) => {
        if (data) {
            const getAnswerArray = answerArray;

            for (var i = 0; i < getAnswerArray.length; i++) {
                if (
                    openDeleteAnswerModal.test_result_id ===
                    getAnswerArray[i].test_result_id
                ) {
                    if (getAnswerArray[i].result.is_hidden === 1) {
                        getAnswerArray[i].result.is_hidden = 0;
                    } else {
                        getAnswerArray[i].result.is_hidden = 1;
                    }
                }
            }
        }
        setOpenDeleteAnswerModal({
            active: false,
            test_result_id: null,
            hidden_result: false,
        });
    };

    const reportAnswerModal = (id) => {
        setOpenReportAnswerModal({ active: true, answer_id: id });
    };

    const closeReportAnswerModal = (data) => {
        setOpenReportAnswerModal({ active: false, answer_id: null });
    };

    const searchData = (search) => {
        setSearch(search);
        resetAiSummaryState();

        if (metaData.userType === "aggregated") {
            const dataAnswer = questionArray.filter(
                (item, indexItem) => indexItem + 1 === isActive
            )[0];
            if (dataAnswer) {
                const newAggregrateArray = dataAnswer.aggregate.filter(
                    (items) =>
                        items.option
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) > -1
                );
                setAggregrateArray(newAggregrateArray);
            }
        } else {
            setSearchLoading(true);
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
            searchDebounceRef.current = setTimeout(() => {
                if (searchController.current) {
                    searchController.current.abort();
                }
                const controller = new AbortController();
                searchController.current = controller;

                let guest_result_token = "";
                if (location.pathname.slice(1, 2) === "v") {
                    guest_result_token = ReactSession.get("guest_result_token");
                }
                let admin_result_token = "";
                if (location.pathname.slice(1, 2) === "a") {
                    admin_result_token = ReactSession.get("admin_result_token");
                }

                let token = ReactSession.get("token");
                getLoadMoreQuestionData(
                    {
                        test_id: test_id,
                        test_question_id: metaData.test_question_id,
                        page: 1,
                        type: metaData.questionType,
                        search: search,
                        questiontype: is_introduction ? "Introduction" : "Conclusion",
                        guest_result_token: guest_result_token,
                        admin_result_token: admin_result_token,
                        generate_ai_summary: false,
                    },
                    token,
                    searchController.current?.signal
                ).then((response) => {
                    if (response?.success) {
                        setSearchLoading(false);
                        setAnswerArray(response.data);
                        setMetaData({
                            ...metaData,
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setSearchLoading(false);
                        showToast(response?.message, "error");
                    }
                }).catch(() => {
                    setSearchLoading(false);
                });
            }, 350);
        }
    };

    const searchByUserData = (searchByUser) => {
        setSearchByUser(searchByUser);
        resetAiSummaryState();

        setSearchLoading(true);
        if (searchController.current) {
            searchController.current.abort();
        }
        const controller = new AbortController();

        searchController.current = controller;

        let guest_result_token = "";
        if (location.pathname.slice(1, 2) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";
        if (location.pathname.slice(1, 2) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        let token = ReactSession.get("token");
        getLoadMoreQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: 1,
                type: metaData.questionType,
                search: searchByUser,
                questiontype: is_introduction ? "Introduction" : "Conclusion",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
                generate_ai_summary: false,
            },
            token,
            searchController.current?.signal
        ).then((response) => {
            if (response?.success) {
                setSearchLoading(false);
                setAnswerArray(response.data);
                setMetaData({
                    ...metaData,
                    page: 1,
                    load_more: response.more_records,
                });
            } else {
                setSearchLoading(false);
                showToast(response?.message, "error");
            }
        });
    };

    const searchByRating = (rating) => {
        setSearchLoading(true);
        if (searchController.current) {
            searchController.current.abort();
        }
        const controller = new AbortController();

        searchController.current = controller;

        let guest_result_token = "";
        if (location.pathname.slice(1, 2) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";
        if (location.pathname.slice(1, 2) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        let token = ReactSession.get("token");
        getLoadMoreQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: 1,
                type: metaData.questionType,
                rating: rating,
                questiontype: is_introduction ? "Introduction" : "Conclusion",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
                generate_ai_summary: false,
            },
            token,
            searchController.current?.signal
        ).then((response) => {
            if (response?.success) {
                setSearchLoading(false);
                setAnswerArray(response.data);
                setMetaData({
                    ...metaData,
                    page: 1,
                    load_more: response.more_records,
                });
            } else {
                setSearchLoading(false);
                showToast(response?.message, "error");
            }
        });
    };

    const searchByAggregateData = (searchAggregateData) => {
        setSearchAggregateData(searchAggregateData);
        const dataAnswer = questionArray.filter(
            (item, indexItem) => indexItem + 1 === isActive
        )[0];
        if (dataAnswer) {
            const newAggregrateArray = dataAnswer.aggregate.filter(
                (items) =>
                    items.option
                        .toLowerCase()
                        .indexOf(searchAggregateData.toLowerCase()) > -1
            );
            setAggregrateArray(newAggregrateArray);
        }
    };

    const handleGenerateAISummary = () => {
        if (!metaData.test_question_id) {
            showToast("Question ID is missing", "error");
            return;
        }

        const question_results = answerArray
            .filter((row) => row && row.id != null)
            .map((row) => ({
                id: row.id,
                text: row.answer != null ? String(row.answer) : "",
            }));

        if (question_results.length === 0) {
            showToast("No responses to summarize", "error");
            return;
        }

        if (answerArray.length > MAX_AI_SENTIMENT_ROWS) {
            showToast("The limits on AI sentiment have now been excluded.", "error");
            return;
        }

        const activeQuestionEntry = questionArray.filter(
            (item, indexItem) => indexItem + 1 === isActive
        )[0];

        const question_title =
            activeQuestionEntry?.questions?.question != null
                ? String(activeQuestionEntry.questions.question)
                : "";

        setAiSummaryLoading(true);
        let token = ReactSession.get("token");

        generateAISummary(
            {
                test_id: test_id,
                question_id: metaData.test_question_id,
                type: is_introduction ? "introduction" : "conclusion",
                question_results,
                question_title,
            },
            token
        ).then((response) => {
            setAiSummaryLoading(false);
            if (response?.success) {
                showToast(response?.message || "AI summary generated successfully", "success");

                const aggregateSummary = response?.data?.summary ?? null;
                setAiSummary(aggregateSummary);

                const responsesArray = response.data?.responses || response.data;
                const summaryMap = {};
                if (responsesArray && Array.isArray(responsesArray)) {
                    responsesArray.forEach((summaryItem) => {
                        summaryMap[summaryItem.responseTextId] = {
                            responseText: summaryItem.responseText,
                            label: summaryItem.label,
                            responseTextId: summaryItem.responseTextId,
                        };
                    });
                }

                setHelpfulVote(null);

                const updatedAnswerArray = answerArray.map((item) => {
                    if (summaryMap[item.id]) {
                        return {
                            ...item,
                            ai_summary: summaryMap[item.id],
                        };
                    }
                    return item;
                });
                setAnswerArray(updatedAnswerArray);
            } else {
                showToast(response?.message || "Failed to generate AI summary", "error");
            }
        }).catch((error) => {
            setAiSummaryLoading(false);
            showToast(error.message || "An error occurred while generating AI summary", "error");
        });
    };

    const handleHelpfulVoteChange = (nextVote) => {
        if (nextVote === null) {
            setHelpfulVote(null);
            return;
        }
        if (!metaData.test_question_id) {
            showToast("Question ID is missing", "error");
            return;
        }
        const token = ReactSession.get("token");
        submitAiSummarizeFeedback(
            {
                test_id: Number(test_id),
                question_id: metaData.test_question_id,
                section: is_introduction ? "introduction" : "conclusion",
                ai_feedback: nextVote === "up",
            },
            token
        ).then((response) => {
            if (response != null && response.success !== false) {
                setHelpfulVote(nextVote);
            }
        });
    };

    const renderRankingQuestionTable = () => {
        var colors = [
            { color: "#FF6DB1", text: "" },
            { color: "#9759CB", text: "" },
            { color: "#F2C690", text: "" },
            { color: "#698CE7", text: "" },
            { color: "#31F0E5", text: "" },
            { color: "#378B10", text: "" },
            { color: "#E32F83", text: "" },
            { color: "#793EAB", text: "" },
            { color: "#D7A56A", text: "" },
            { color: "#3668E7", text: "" },
            { color: "#11BFB4", text: "" },
            { color: "#164103", text: "" },
            { color: "#FF8AC1", text: "" },
            { color: "#AC7AD5", text: "" },
            { color: "#FFE2C0", text: "" },
            { color: "#9EB4ED", text: "" },
            { color: "#90F2EC", text: "" },
            { color: "#BFF0A8", text: "" },
            { color: "#A72561", text: "" },
            { color: "#5C208D", text: "" },
            { color: "#C38D4D", text: "" },
            { color: "#0D3BB0", text: "" },
            { color: "#0A877F", text: "" },
            { color: "#A72561", text: "" },
            { color: "#5C208D", text: "" },
            { color: "#C38D4D", text: "" },
            { color: "#06236C", text: "" },
            { color: "#045A54", text: "" },
        ];

        var tableData = [];
        for (var i in rankingTableData[0])
            tableData.push([i, rankingTableData[0][i]]);
        tableData.sort(compare);

        return (
            <div
                ref={scrollContainerRef}
                className={`ranking-table-holder max-height-table  ${isScrolled ? "scrolled" : ""
                    } ${tableData && tableData.length > 8
                        ? "responsive-table-scroll"
                        : ""
                    }`}
            >
                <table className="table prefer-aggregatd-data-table ranking-table">
                    <thead>
                        <tr>
                            <th>Answers</th>
                            {tableData.map(function (item, index) {
                                return (
                                    <th>
                                        {index + 1 === 1
                                            ? "1st"
                                            : index + 1 === 2
                                                ? "2nd"
                                                : index + 1 === 3
                                                    ? "3rd"
                                                    : index + 1 + "th"}
                                    </th>
                                );
                            })}
                            <th className="score-heading-table">
                                <b>Score</b>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map(function (item, index) {
                            return (
                                <tr
                                    className={`${index === 0
                                        ? "ranking-table-first-row"
                                        : ""
                                        }`}
                                >
                                    <td>
                                        <div className="d-flex table-answer-column-outer">
                                            <div
                                                style={{
                                                    backgroundColor:
                                                        colors[index].color,
                                                }}
                                                className="table-color-box"
                                            ></div>
                                            <span
                                                className={`table-answer-column ${test.language === "ar"
                                                    ? "arabic-font"
                                                    : ""
                                                    }`}
                                            >
                                                {item[0]}
                                            </span>
                                        </div>
                                    </td>
                                    {tableData.map(function (itemm, i) {
                                        return (
                                            <td>
                                                <div className="d-flex table-answer-column-votes">
                                                    <span className="table-votes">
                                                        {
                                                            item[1]["votes"][
                                                            i + 1
                                                            ]
                                                        }
                                                    </span>
                                                    <span className="table-percentage">
                                                        {" "}
                                                        (
                                                        {Math.round(
                                                            ((item[1]["votes"][
                                                                i + 1
                                                            ] *
                                                                100) /
                                                                metaData.totalResultCount) *
                                                            100
                                                        ) / 100}
                                                        %)
                                                    </span>
                                                </div>
                                            </td>
                                        );
                                    })}
                                    <td>
                                        {Math.round(
                                            item[1]["averageranking"] * 100
                                        ) / 100}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };

    const [headerHeight, setHeaderHeight] = useState(0);

    const handleHeaderHeight = (height) => {
        setHeaderHeight(height);
    };

    return (
        <LayoutResearcher
            isSharedLink={isSharedLink}
            fixed_header_target={true}
            isLoading={false}
            wrapClass={
                "researcher-test-view-overflow overflow-visible researcher-resultwrap"
            }
            resultHeaderClass={"result-header"}
            skipCheck={false}
            extendedFooter={false}
            activeMenu={""}
            openSupportPanel={show_support_panel}
            hideSupportPanel={() => {
                setShowSupportPanel(false);
            }}
        >
            <Helmet>
                <title>
                    {is_introduction
                        ? "Introduction questions"
                        : "Conclusion questions"}{" "}
                    {test && test.methodology
                        ? " - " + renderTestTitle(test.methodology)
                        : ""}{" "}
                    | UserQ
                </title>
            </Helmet>
            {isLoading && (
                <div className="page-loader loader_section full-page-loader">
                    <LoadingIcon />
                </div>
            )}

            {!isLoading && test && (
                <div className="three-column-layout two-column-layout">
                    <TestResultsHeader
                        project={project}
                        isSharedLink={isSharedLink}
                        test={test}
                        endedOn={
                            test.status === "completed"
                                ? moment.utc(test.ended_on).format("DD-MM-Y")
                                : ""
                        }
                        callbackTopbar={callbackTopbar}
                    />
                    <div className="three-column-layout-body">
                        <div className="three-column-layout-left">
                            <TestResultsSidebarNavigation
                                isSharedLink={isSharedLink}
                                methodology={
                                    test.methodology === "Five Seconds Test"
                                        ? "5 second test"
                                        : test.methodology
                                }
                                selected_index={
                                    location.pathname.split("/").pop() ===
                                        "introduction-questions"
                                        ? 3
                                        : 5
                                }
                                test_id={
                                    location.pathname.slice(1, 2) === "v"
                                        ? test_id
                                        : test.id
                                }
                                screening={
                                    test &&
                                        test.screening_questions &&
                                        test.screening_questions.length > 0
                                        ? "Yes"
                                        : "No"
                                }
                            />
                        </div>

                        <div className="two-column-right-side">
                            {sectionLoading && (
                                <div className="page-loader accountloading-box result-sections-loader">
                                    <LoadingIcon />
                                </div>
                            )}

                            {!sectionLoading &&
                                questionArray &&
                                questionArray.length > 0 && (
                                    <div className="bd-question-view-wrap">

                                        {aggrgateQuestionsResultCount > 0 && (
                                            <div className="question-result-header question-result-data">
                                                <QuestionsDropdown
                                                    questionArray={
                                                        questionArray
                                                    }
                                                    questionType={
                                                        "conclusionOrIntroduction"
                                                    }
                                                    changeActiveQuestionProp={(
                                                        index
                                                    ) => {
                                                        changeActiveQuestion(
                                                            index,
                                                            questionArray
                                                        );
                                                        setSortBy(null);
                                                        setSortOrder(null);
                                                    }}
                                                    dropdownOpen={(state) =>
                                                        setDropdownOpen(state)
                                                    }
                                                    resultCount={
                                                        metaData.totalResultCount
                                                    }
                                                    test={test}
                                                    active={isActive}
                                                    onHeaderHeightChange={
                                                        handleHeaderHeight
                                                    }
                                                />
                                                {metaData.totalResultCount >=
                                                    1 &&
                                                    ([
                                                        "singlechoice",
                                                        "multiplechoice",
                                                        "likertscale",
                                                        "likertscale_single",
                                                        "ratingscale",
                                                    ].includes(
                                                        metaData.questionType
                                                    ) ? (
                                                        <InnerNavigationTab
                                                            type="tab"
                                                            activeMenu={
                                                                activeMenu
                                                            }
                                                            cssClasses="result-navigation-outer question-navigator-active-link result-navigation pt-3 "
                                                            onTabChange={(
                                                                key
                                                            ) => {
                                                                setActiveMenu(
                                                                    key
                                                                );
                                                            }}
                                                            items={[
                                                                {
                                                                    key: `chart`,
                                                                    label: "Chart",
                                                                },
                                                                ...(metaData.questionType !==
                                                                    "ratingscale" &&
                                                                    metaData.questionType !==
                                                                    "likertscale_single"
                                                                    ? [
                                                                        {
                                                                            key: `aggregate-data`,
                                                                            label: "Aggregated data",
                                                                        },
                                                                    ]
                                                                    : []),
                                                                {
                                                                    key: `byuser-table`,
                                                                    label: "By user",
                                                                },
                                                            ]}
                                                            scrollSpy={true}
                                                            scrollSpace={
                                                                headerHeight
                                                            }
                                                        />
                                                    ) : (
                                                        <div className="accountnaviagtion-outer result-navigation-outer question-navigator-active-link border-0"></div>
                                                    ))}
                                            </div>
                                        )}

                                        {metaData.totalResultCount < 1 ? (
                                            <div
                                                className={`no-participants-data no-questions-data ${dropdownOpen
                                                    ? "black-overlay"
                                                    : ""
                                                    }`}
                                            >
                                                <div
                                                    className="no-page-data-wrap"
                                                    style={{
                                                        marginTop: "80px",
                                                    }}
                                                >
                                                    <div className="no-data-icon">
                                                        <Icon
                                                            value={"attention"}
                                                            colorClass={
                                                                "gray-700-svg"
                                                            }
                                                            size={"large"}
                                                        />
                                                    </div>

                                                    <Text
                                                        type={"subtitle-1"}
                                                        fontWeight="medium-font"
                                                    >
                                                        {aggrgateQuestionsResultCount >
                                                            0 ? (
                                                            <>
                                                                Details are not
                                                                available at the
                                                                moment as this
                                                                question didn’t
                                                                receive any
                                                                response yet.
                                                                Users might have
                                                                skipped this
                                                                question.
                                                            </>
                                                        ) : (
                                                            <>
                                                                Details are not
                                                                available at the
                                                                moment as the
                                                                test didn’t
                                                                receive any
                                                                response yet.
                                                                Please come back
                                                                later.
                                                            </>
                                                        )}
                                                    </Text>
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                className={`question-result-data  ${dropdownOpen ? "black-overlay" : ""}`}>

                                                {metaData.questionType === "free" && (
                                                    <div className="free-question-result-data test-result-inner-data">
                                                        {/* Show AI Summary if generated, otherwise show banner */}
                                                        {aiAssistantEnabled &&
                                                            (Boolean(
                                                                aiSummary != null &&
                                                                String(aiSummary).trim() !== ""
                                                            ) ||
                                                                answerArray.some(
                                                                    (row) =>
                                                                        row &&
                                                                        row.ai_summary
                                                                )) ? (
                                                            <div
                                                                className={`ai-summary-box ai-summary-box-screenshot ${aiAssistantEnabled
                                                                    ? ""
                                                                    : "ai-summary-box-off"
                                                                    }`}
                                                            >
                                                                <div className="ai-summary-box-header">
                                                                    <div className="ai-summary-box-header-left">
                                                                        <Text
                                                                            type="subtitle-2"
                                                                            fontWeight="bold-font"
                                                                        >
                                                                            Summary
                                                                        </Text>

                                                                        <span className="ai-summary-box-header-icon">
                                                                            <Icon
                                                                                value="Ai"
                                                                                size="small"
                                                                                colorClass={
                                                                                    aiAssistantEnabled
                                                                                        ? "ai-feature-banner-icon-svg-blue"
                                                                                        : "ai-feature-banner-icon-svg-off"
                                                                                }
                                                                            />
                                                                            <Text
                                                                                type="caption"
                                                                                fontWeight="medium-font"
                                                                                cssClasses={
                                                                                    aiAssistantEnabled
                                                                                        ? "ai-summary-box-powered"
                                                                                        : "ai-summary-box-powered-off"
                                                                                }
                                                                            >
                                                                                Powered by AI (beta)
                                                                            </Text>
                                                                        </span>
                                                                    </div>

                                                                    <div className="ai-summary-box-header-right">
                                                                        <div className="ai-summary-box-assistant-toggle">
                                                                            <Text
                                                                                type="body-text-2"
                                                                                fontWeight="medium-font"
                                                                                cssClasses="ai-summary-box-assistant-label"
                                                                            >
                                                                                AI assistant
                                                                            </Text>
                                                                            <label className="switch ai-toggle-btn-wrap toggle-btn-wrap ai-summary-assistant-switch">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={aiAssistantEnabled}
                                                                                    onChange={(e) =>
                                                                                        handleAiAssistantToggle(
                                                                                            e.target.checked
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <span className="slider round" />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {aiAssistantEnabled && (
                                                                    <>
                                                                        <div className="ai-summary-box-body">
                                                                            {aiSummary != null &&
                                                                                String(aiSummary).trim() !== "" && (
                                                                                    <Text
                                                                                        type="body-text-3"
                                                                                        fontWeight="normal-font"
                                                                                        cssClasses="ai-summary-box-summary-text"
                                                                                    >
                                                                                        {aiSummary}
                                                                                    </Text>
                                                                                )}
                                                                        </div>

                                                                        <div className="ai-summary-box-footer">
                                                                            <Text
                                                                                type="body-text-2"
                                                                                fontWeight="medium-font"
                                                                                cssClasses="ai-summary-box-helpful-text"
                                                                            >
                                                                                Was this helpful?
                                                                            </Text>

                                                                            <div className="ai-summary-box-helpful-icons">
                                                                                <button
                                                                                    type="button"
                                                                                    className={`ai-summary-box-helpful-btn ${helpfulVote === "up"
                                                                                        ? "is-thumb-up-selected"
                                                                                        : ""
                                                                                        }`}
                                                                                    aria-label="helpful"
                                                                                    aria-pressed={
                                                                                        helpfulVote === "up"
                                                                                    }
                                                                                    onClick={() =>
                                                                                        handleHelpfulVoteChange(
                                                                                            helpfulVote === "up"
                                                                                                ? null
                                                                                                : "up"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Icon
                                                                                        value="Like"
                                                                                        size="medium"
                                                                                        colorClass="ai-feature-banner-icon-svg"
                                                                                    />
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className={`ai-summary-box-helpful-btn ${helpfulVote === "down"
                                                                                        ? "is-thumb-down-selected"
                                                                                        : ""
                                                                                        }`}
                                                                                    aria-label="not helpful"
                                                                                    aria-pressed={
                                                                                        helpfulVote === "down"
                                                                                    }
                                                                                    onClick={() =>
                                                                                        handleHelpfulVoteChange(
                                                                                            helpfulVote === "down"
                                                                                                ? null
                                                                                                : "down"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <span className="ai-summary-thumb-down">
                                                                                        <Icon
                                                                                            value="Like"
                                                                                            size="medium"
                                                                                            colorClass="ai-feature-banner-icon-svg"
                                                                                        />
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <AIFeatureBanner
                                                                parentClassName={
                                                                    is_introduction
                                                                        ? "ai-feature-banner-introduction"
                                                                        : "ai-feature-banner-conclusion"
                                                                }
                                                                onGenerateSummary={() => {
                                                                    setAiAssistantEnabled(true);
                                                                    handleGenerateAISummary();
                                                                }}
                                                                loading={aiSummaryLoading}
                                                            />
                                                        )}
                                                        <div className="free-question-table-header" id="chart">
                                                            <div className="free-question-table-header-left" id="chart-free">
                                                                <Text type="subtitle-1" fontWeight="medium-font">
                                                                    Free text
                                                                </Text>
                                                            </div>
                                                            <div className="free-question-table-header-right">
                                                                <Search
                                                                    size={
                                                                        "small"
                                                                    }
                                                                    placeholder="Search in answers"
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        searchData(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    onClear={() => {
                                                                        setTimeout(
                                                                            () => {
                                                                                setSearch(
                                                                                    ""
                                                                                );
                                                                                searchData(
                                                                                    ""
                                                                                );
                                                                            },
                                                                            1000
                                                                        );
                                                                    }}
                                                                    loading={
                                                                        searchLoading
                                                                    }
                                                                    value={
                                                                        search
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <ByUserTable
                                                            aiAssistantEnabled={
                                                                aiAssistantEnabled
                                                            }
                                                            metaData={metaData}
                                                            answerArray={answerArray}
                                                            sortData={sortData}
                                                            hideParticipantModal={
                                                                hideParticipantModal
                                                            }
                                                            reportAnswerModal={
                                                                reportAnswerModal
                                                            }
                                                            search={search}
                                                            test={test}
                                                            loadMore={loadMore}
                                                            loadMoreLoading={
                                                                loadMoreLoading
                                                            }
                                                            clearSearch={() => {
                                                                setSearch("");
                                                                searchData("");
                                                            }}
                                                        />
                                                    </div>
                                                )}

                                                {metaData.questionType === "singlechoice" && (
                                                    <div className="free-question-result-data test-result-inner-data test-class">
                                                        <div id="chart">
                                                            <div
                                                                className="free-question-table-header"
                                                                id="chart-singlechoice"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        Chart
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <div className="chart-data">
                                                                <PieStatsBoxSingleChoice
                                                                    data={
                                                                        chartData
                                                                    }
                                                                    sortedchartData={
                                                                        sortedchartData
                                                                    }
                                                                    title={
                                                                        <span>
                                                                            {
                                                                                metaData.totalResultCount
                                                                            }
                                                                            {metaData.totalResultCount ===
                                                                                1
                                                                                ? " Answer"
                                                                                : " Answers"}
                                                                        </span>
                                                                    }
                                                                    test={test}
                                                                    totalAnswers={
                                                                        metaData.totalResultCount
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="aggregated-data-table"
                                                            id="aggregate-data"
                                                        >
                                                            <div
                                                                className="free-question-table-header"
                                                                id="aggregate-data-singlechoice"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        Aggregated
                                                                        data
                                                                    </Text>
                                                                </div>
                                                                <div className="free-question-table-header-right">
                                                                    <Search
                                                                        size={
                                                                            "small"
                                                                        }
                                                                        placeholder="Search in answers"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            searchByAggregateData(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        onClear={() => {
                                                                            setTimeout(
                                                                                () => {
                                                                                    setSearchAggregateData(
                                                                                        ""
                                                                                    );
                                                                                    searchByAggregateData(
                                                                                        ""
                                                                                    );
                                                                                },
                                                                                0
                                                                            );
                                                                        }}
                                                                        loading={
                                                                            false
                                                                        }
                                                                        value={
                                                                            searchAggregateData
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <AggregatedDataTable
                                                                metaData={
                                                                    metaData
                                                                }
                                                                aggregrateArray={
                                                                    aggregrateArray
                                                                }
                                                                sortData={
                                                                    sortData
                                                                }
                                                                search={
                                                                    searchAggregateData
                                                                }
                                                                test={test}
                                                                clearSearch={() => {
                                                                    setSearchAggregateData(
                                                                        ""
                                                                    );
                                                                    searchByAggregateData(
                                                                        ""
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="by-user-table"
                                                            id="byuser-table"
                                                        >
                                                            <div
                                                                className="free-question-table-header"
                                                                id="byuser-singlechoice"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        By user
                                                                    </Text>
                                                                </div>
                                                                <div className="free-question-table-header-right">
                                                                    <Search
                                                                        size={
                                                                            "small"
                                                                        }
                                                                        placeholder="Search in answers"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            searchByUserData(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        onClear={() => {
                                                                            setTimeout(
                                                                                () => {
                                                                                    setSearchByUser(
                                                                                        ""
                                                                                    );
                                                                                    searchByUserData(
                                                                                        ""
                                                                                    );
                                                                                },
                                                                                0
                                                                            );
                                                                        }}
                                                                        loading={
                                                                            searchLoading
                                                                        }
                                                                        value={
                                                                            searchByUser
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>

                                                            <ByUserTable
                                                                aiAssistantEnabled={
                                                                    aiAssistantEnabled
                                                                }
                                                                metaData={
                                                                    metaData
                                                                }
                                                                answerArray={
                                                                    answerArray
                                                                }
                                                                sortData={
                                                                    sortData
                                                                }
                                                                hideParticipantModal={
                                                                    hideParticipantModal
                                                                }
                                                                reportAnswerModal={
                                                                    reportAnswerModal
                                                                }
                                                                search={
                                                                    searchByUser
                                                                }
                                                                test={test}
                                                                loadMore={
                                                                    loadMore
                                                                }
                                                                loadMoreLoading={
                                                                    loadMoreLoading
                                                                }
                                                                clearSearch={() => {
                                                                    setSearchByUser(
                                                                        ""
                                                                    );
                                                                    searchByUserData(
                                                                        ""
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                {metaData.questionType === "multiplechoice" && (
                                                    <div className="free-question-result-data test-result-inner-data">
                                                        <div id="chart">
                                                            <div
                                                                className="free-question-table-header-1"
                                                                id="chart-multiplechoice"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                </div>
                                                            </div>
                                                            <div className="chart-data">
                                                                <div className="parti-ga-grapg-area">
                                                                    <HorizontalBarChartStatsBoxMultipleChoice
                                                                        resultCount={
                                                                            metaData.totalResultCount
                                                                        }
                                                                        test={
                                                                            test
                                                                        }
                                                                        title={
                                                                            "Chart"
                                                                        }
                                                                        data={
                                                                            chartData
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="aggregated-data-table"
                                                            id="aggregate-data"
                                                        >
                                                            <div
                                                                className="free-question-table-header"
                                                                id="aggregate-data-multiplechoice"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        Aggregated
                                                                        data
                                                                    </Text>
                                                                </div>
                                                                <div className="free-question-table-header-right">
                                                                    <Search
                                                                        size={
                                                                            "small"
                                                                        }
                                                                        placeholder="Search in answers"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            searchByAggregateData(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        onClear={() => {
                                                                            setTimeout(
                                                                                () => {
                                                                                    setSearchAggregateData(
                                                                                        ""
                                                                                    );
                                                                                    searchByAggregateData(
                                                                                        ""
                                                                                    );
                                                                                },
                                                                                0
                                                                            );
                                                                        }}
                                                                        loading={
                                                                            false
                                                                        }
                                                                        value={
                                                                            searchAggregateData
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <AggregatedDataTable
                                                                metaData={
                                                                    metaData
                                                                }
                                                                aggregrateArray={
                                                                    aggregrateArray
                                                                }
                                                                sortData={
                                                                    sortData
                                                                }
                                                                search={
                                                                    searchAggregateData
                                                                }
                                                                test={test}
                                                                clearSearch={() => {
                                                                    setSearchAggregateData(
                                                                        ""
                                                                    );
                                                                    searchByAggregateData(
                                                                        ""
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="by-user-table"
                                                            id="byuser-table"
                                                        >
                                                            <div
                                                                className="free-question-table-header"
                                                                id="byuser-multiplechoice"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        By user
                                                                    </Text>
                                                                </div>
                                                                <div className="free-question-table-header-right">
                                                                    <Search
                                                                        size={
                                                                            "small"
                                                                        }
                                                                        placeholder="Search in answers"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            searchByUserData(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        onClear={() => {
                                                                            setTimeout(
                                                                                () => {
                                                                                    setSearchByUser(
                                                                                        ""
                                                                                    );
                                                                                    searchByUserData(
                                                                                        ""
                                                                                    );
                                                                                },
                                                                                0
                                                                            );
                                                                        }}
                                                                        loading={
                                                                            searchLoading
                                                                        }
                                                                        value={
                                                                            searchByUser
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>

                                                            <ByUserTable
                                                                aiAssistantEnabled={
                                                                    aiAssistantEnabled
                                                                }
                                                                metaData={
                                                                    metaData
                                                                }
                                                                answerArray={
                                                                    answerArray
                                                                }
                                                                sortData={
                                                                    sortData
                                                                }
                                                                hideParticipantModal={
                                                                    hideParticipantModal
                                                                }
                                                                reportAnswerModal={
                                                                    reportAnswerModal
                                                                }
                                                                search={
                                                                    searchByUser
                                                                }
                                                                test={test}
                                                                loadMore={
                                                                    loadMore
                                                                }
                                                                loadMoreLoading={
                                                                    loadMoreLoading
                                                                }
                                                                clearSearch={() => {
                                                                    setSearchByUser(
                                                                        ""
                                                                    );
                                                                    searchByUserData(
                                                                        ""
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                {(metaData.questionType === "likertscale" || metaData.questionType === "likertscale_single") && (
                                                    <div
                                                        className="free-question-result-data test-result-inner-data"
                                                        id={
                                                            metaData.questionType ===
                                                                "likertscale_single"
                                                                ? "chart-likertscale_single"
                                                                : "chart-likertscale"
                                                        }
                                                    >
                                                        <div id="chart">
                                                            <div className="free-question-table-header">
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        Chart
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <div className="chart-data">
                                                                {matrixArray.length >
                                                                    0 &&
                                                                    Object.keys(
                                                                        likertQuestion
                                                                    ).length !==
                                                                    0 && (
                                                                        <LikertScaleChart
                                                                            data={
                                                                                matrixArray
                                                                            }
                                                                            likertQuestion={
                                                                                likertQuestion
                                                                            }
                                                                            test={
                                                                                test
                                                                            }
                                                                        />
                                                                    )}
                                                            </div>
                                                        </div>

                                                        {metaData.questionType !==
                                                            "likertscale_single" && (
                                                                <div
                                                                    className="aggregated-data-table"
                                                                    id="aggregate-data"
                                                                >
                                                                    <div
                                                                        className="free-question-table-header"
                                                                        id="aggregate-data-likertscale"
                                                                    >
                                                                        <div className="free-question-table-header-left">
                                                                            <Text
                                                                                type="h4"
                                                                                fontWeight="bold-font"
                                                                            >
                                                                                Aggregated
                                                                                data
                                                                            </Text>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className={`likert-area-chart ${test.language ===
                                                                            "ar"
                                                                            ? "arabic-font"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {matrixArray.length >
                                                                            0 &&
                                                                            Object.keys(
                                                                                likertQuestion
                                                                            )
                                                                                .length !==
                                                                            0 && (
                                                                                <LikertScaleAggregateData
                                                                                    data={
                                                                                        matrixArray
                                                                                    }
                                                                                    likertQuestion={
                                                                                        likertQuestion
                                                                                    }
                                                                                />
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        <div
                                                            className="by-user-table"
                                                            id="byuser-table"
                                                        >
                                                            <div
                                                                className="free-question-table-header"
                                                                id={
                                                                    metaData.questionType ===
                                                                        "likertscale_single"
                                                                        ? "byuser-likertscale_single"
                                                                        : "byuser-likertscale"
                                                                }
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        By user
                                                                    </Text>
                                                                </div>
                                                            </div>

                                                            {Object.keys(
                                                                likertQuestion
                                                            ).length !== 0 && (
                                                                    <LikertScaleByUser
                                                                        likertQuestion={
                                                                            likertQuestion
                                                                        }
                                                                        metaData={
                                                                            metaData
                                                                        }
                                                                        test_id={
                                                                            test_id
                                                                        }
                                                                        test={test}
                                                                        answerArray={
                                                                            answerArray
                                                                        }
                                                                        hideParticipantModal={
                                                                            hideParticipantModal
                                                                        }
                                                                        reportAnswerModal={
                                                                            reportAnswerModal
                                                                        }
                                                                        loadMore={
                                                                            loadMore
                                                                        }
                                                                        loadMoreLoading={
                                                                            loadMoreLoading
                                                                        }
                                                                    />
                                                                )}
                                                        </div>
                                                    </div>
                                                )}

                                                {metaData.questionType === "rankingscale" && (
                                                    <div
                                                        className="test-result-inner-data parti-ga-grapg-area"
                                                        id="chart"
                                                    >
                                                        <div
                                                            className="barchart-ranking-scale"
                                                            id="chart-rankingscale"
                                                        >
                                                            <HorizontalBarChartStatsBoxRankingScale
                                                                test={test}
                                                                rankingchartData={
                                                                    rankingchartData
                                                                }
                                                            />
                                                        </div>
                                                        <div className="ranking-scale-table mt-40">
                                                            {renderRankingQuestionTable()}
                                                        </div>
                                                        <div className="ranking-page-infodata-wrap">
                                                            <h3>
                                                                How to read this
                                                                bar chart?
                                                            </h3>
                                                            <p>
                                                                The bar chart is
                                                                based on the
                                                                score each
                                                                ranked option
                                                                has received.
                                                                The scores
                                                                represent the
                                                                average ranking.
                                                            </p>
                                                            <h3>
                                                                How the scores
                                                                are calculated?
                                                            </h3>
                                                            <p>
                                                                Think of the
                                                                score as a
                                                                weighted
                                                                average. Suppose
                                                                you have 5
                                                                options for
                                                                testers to rank.
                                                                The testers’
                                                                most preferred
                                                                option (ranked
                                                                as #1 most of
                                                                the times) is
                                                                given the
                                                                largest weight
                                                                (in this case
                                                                5). Their least
                                                                preferred option
                                                                has a weight of
                                                                1. The weights
                                                                are then
                                                                multiplied by
                                                                the numbers of
                                                                testers selected
                                                                a particular
                                                                option. Their
                                                                sum is divided
                                                                by the total
                                                                number of
                                                                testers.
                                                            </p>
                                                            <div className="response-text-wrap mathmaticbox">
                                                                <p>
                                                                    X
                                                                    <sub>1</sub>{" "}
                                                                    W
                                                                    <sub>1</sub>{" "}
                                                                    + X
                                                                    <sub>2</sub>{" "}
                                                                    W
                                                                    <sub>2</sub>
                                                                    + X
                                                                    <sub>3</sub>{" "}
                                                                    W
                                                                    <sub>3</sub>{" "}
                                                                    + ... + X
                                                                    <sub>n</sub>{" "}
                                                                    W
                                                                    <sub>n</sub>
                                                                </p>
                                                                <span>
                                                                    Total
                                                                    responses
                                                                </span>
                                                            </div>
                                                            <div className="ranking-wrap-info-bottom">
                                                                <strong>
                                                                    Where:
                                                                </strong>
                                                                <p>
                                                                    X - number
                                                                    of testers
                                                                </p>
                                                                <p>
                                                                    W - weight
                                                                    of the
                                                                    ranked
                                                                    option
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {metaData.questionType === "ratingscale" && (
                                                    <div className="free-question-result-data test-result-inner-data">
                                                        <div id="chart">
                                                            <div
                                                                className="free-question-table-header"
                                                                id="chart-ratingscale"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        Chart
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <div className="chart-data">
                                                                {matrixArray &&
                                                                    Object.keys(
                                                                        likertQuestion
                                                                    ).length !==
                                                                    0 && (
                                                                        <>
                                                                            <RatingScaleChart
                                                                                test={
                                                                                    test
                                                                                }
                                                                                data={
                                                                                    matrixArray
                                                                                }
                                                                                question={{
                                                                                    type:
                                                                                        likertQuestion.scale_type ===
                                                                                            "Emotions"
                                                                                            ? "emoticons"
                                                                                            : likertQuestion.scale_type,
                                                                                    scale: likertQuestion.scale_length.match(
                                                                                        /\d+/
                                                                                    )[0],
                                                                                    labels: likertQuestion.labels,
                                                                                }}
                                                                                predictions={
                                                                                    predictions
                                                                                }
                                                                            />
                                                                        </>
                                                                    )}
                                                            </div>
                                                        </div>

                                                        <div
                                                            className="by-user-table"
                                                            id="byuser-table"
                                                        >
                                                            <div
                                                                className="free-question-table-header"
                                                                id="byuser-ratingscale"
                                                            >
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        type="h4"
                                                                        fontWeight="bold-font"
                                                                    >
                                                                        By user
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <div className="free-question-table-header">
                                                                <div className="free-question-table-header-left">
                                                                    <Text
                                                                        cssClasses={
                                                                            "gray-color"
                                                                        }
                                                                        type="body-text-3"
                                                                        fontWeight="medium-font"
                                                                    >
                                                                        {
                                                                            metaData.totalResultCount
                                                                        }{" "}
                                                                        answer
                                                                        {metaData.totalResultCount >
                                                                            1
                                                                            ? "s"
                                                                            : ""}
                                                                    </Text>
                                                                </div>

                                                                <div className="free-question-table-header-right">
                                                                    {Object.keys(
                                                                        likertQuestion
                                                                    ).length !==
                                                                        0 && (
                                                                            <RatingMultiSelect
                                                                                onChange={(
                                                                                    rating
                                                                                ) => {
                                                                                    searchByRating(
                                                                                        rating
                                                                                    );
                                                                                }}
                                                                                value={
                                                                                    rating
                                                                                }
                                                                                type={(function () {
                                                                                    var scale =
                                                                                    {
                                                                                        Stars: "stars",
                                                                                        Emotions:
                                                                                            "emoticons",
                                                                                        Numeric:
                                                                                            "numeric",
                                                                                    };

                                                                                    return scale[
                                                                                        likertQuestion
                                                                                            .scale_type
                                                                                    ];
                                                                                })()}
                                                                                scale={
                                                                                    likertQuestion.scale_length.match(
                                                                                        /\d+/
                                                                                    )[0]
                                                                                }
                                                                            />
                                                                        )}
                                                                </div>
                                                            </div>

                                                            {Object.keys(
                                                                likertQuestion
                                                            ).length !== 0 && (
                                                                    <ByUserTable
                                                                        aiAssistantEnabled={
                                                                            aiAssistantEnabled
                                                                        }
                                                                        metaData={
                                                                            metaData
                                                                        }
                                                                        answerArray={
                                                                            answerArray
                                                                        }
                                                                        sortData={
                                                                            sortData
                                                                        }
                                                                        hideParticipantModal={
                                                                            hideParticipantModal
                                                                        }
                                                                        reportAnswerModal={
                                                                            reportAnswerModal
                                                                        }
                                                                        search={
                                                                            search
                                                                        }
                                                                        test={test}
                                                                        loadMore={
                                                                            loadMore
                                                                        }
                                                                        loadMoreLoading={
                                                                            loadMoreLoading
                                                                        }
                                                                        clearSearch={() => {
                                                                            setRating(
                                                                                []
                                                                            );
                                                                            searchByRating(
                                                                                []
                                                                            );
                                                                        }}
                                                                        question={{
                                                                            type:
                                                                                likertQuestion.scale_type ===
                                                                                    "Emotions"
                                                                                    ? "emoticons"
                                                                                    : likertQuestion.scale_type,
                                                                            scale: likertQuestion.scale_length.match(
                                                                                /\d+/
                                                                            )[0],
                                                                        }}
                                                                    />
                                                                )}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="bd-question-bottom-pagination-arrow prev-next-button-bottom">
                                                    <div className="bd-que-slide-arrow tablebottompagination">
                                                        <Button
                                                            type={"secondary"}
                                                            microLoading={false}
                                                            label={
                                                                "Previous question"
                                                            }
                                                            size={"medium"}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (
                                                                    isActive > 1
                                                                ) {
                                                                    changeActiveQuestion(
                                                                        isActive -
                                                                        1,
                                                                        questionArray
                                                                    );
                                                                }
                                                            }}
                                                            iconLeft={
                                                                <Icon
                                                                    value={
                                                                        "back-arrow"
                                                                    }
                                                                    size={
                                                                        "medium"
                                                                    }
                                                                />
                                                            }
                                                            state={`${isActive === 1
                                                                ? "disabled"
                                                                : ""
                                                                }`}
                                                        />
                                                        <Button
                                                            type={"secondary"}
                                                            label={
                                                                "Next question"
                                                            }
                                                            size={"medium"}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (
                                                                    isActive <
                                                                    questionArray.length
                                                                ) {
                                                                    changeActiveQuestion(
                                                                        isActive +
                                                                        1,
                                                                        questionArray
                                                                    );
                                                                }
                                                            }}
                                                            iconRight={
                                                                <Icon
                                                                    value={
                                                                        "forward-arrow"
                                                                    }
                                                                    size={
                                                                        "medium"
                                                                    }
                                                                />
                                                            }
                                                            state={`${isActive ===
                                                                questionArray.length
                                                                ? "disabled"
                                                                : ""
                                                                }`}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                            {!sectionLoading &&
                                questionArray &&
                                questionArray.length === 0 && (
                                    <div className={`no-participants-data no-questions-data no-questions-added`}>
                                        <div className="no-page-data-wrap" style={{ marginTop: "80px" }}>
                                            <div className="no-data-icon">
                                                <Icon
                                                    value={"attention"}
                                                    colorClass={"gray-700-svg"}
                                                    size={"large"}
                                                />
                                            </div>

                                            <Text
                                                type={"subtitle-1"}
                                                fontWeight="medium-font"
                                            >
                                                You have not added any
                                                {location.pathname
                                                    .split("/")
                                                    .pop() ===
                                                    "introduction-questions"
                                                    ? " introduction "
                                                    : " conclusion "}
                                                questions to your test.
                                            </Text>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                    <HideParticipant
                        test_id={test_id}
                        openModal={openDeleteAnswerModal}
                        closeModal={closeDeleteAnswerModal}
                    />
                    <ReportAnswer
                        test_id={test_id}
                        openModal={openReportAnswerModal}
                        closeModal={closeReportAnswerModal}
                    />
                </div>
            )}

            {!isSharedLink && (
                <a
                    onClick={(e) => {
                        e.preventDefault();

                        setShowSupportPanel(true);
                    }}
                    href={process.env.REACT_APP_URL + "r/support"}
                    target="_blank"
                    rel="noreferrer"
                    className="support-button"
                >
                    <Icon
                        value={"support"}
                        colorClass={"gray-50-svg"}
                        size={"medium"}
                    />
                    Support
                </a>
            )}
        </LayoutResearcher>
    );
}
